import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function ArtaAbout() {
  return <section className="py-20 lg:py-32 bg-brand-cream relative overflow-hidden" data-id="element-80">
      <div className="max-w-7xl mx-auto px-6" data-id="element-81">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="lg:hidden mb-10 text-center" data-id="element-82">
          <SectionHeading title="Cine sunt eu și de ce am creat acest curs" centered={true} data-id="element-83" />
        </motion.div>

        <div className="grid lg:grid-cols-[2fr_3fr] gap-12 lg:gap-20 items-stretch" data-id="element-84">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="relative w-full max-w-[400px] mx-auto lg:mx-0 lg:max-w-none aspect-[3/4] lg:aspect-auto lg:min-h-full" data-id="element-85">
            <div className="hidden lg:block absolute -top-6 -left-6 w-24 h-24 border-[1.5px] border-brand-gold/30 rounded-full pointer-events-none" data-id="element-86" />
            <div className="hidden lg:block absolute -bottom-6 -right-6 w-32 h-32 border border-brand-gold/25 rounded-full pointer-events-none" data-id="element-87" />
            <div className="hidden lg:block absolute -top-3 -right-3 w-2.5 h-2.5 bg-brand-gold/70 rotate-45 pointer-events-none" data-id="element-88" />

            <div className="absolute inset-0 rounded-[32px] overflow-hidden shadow-warm" data-id="element-89">
              <img src="https://cdn.magicpatterns.com/uploads/hbWtuJ6aCvHUuJajw2QL9A/Screenshot_2026-05-15_at_21.29.02.png" alt="Adrian Huniade" className="absolute inset-0 w-full h-full object-cover object-center" data-id="element-90" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-91">
            <div className="hidden lg:block" data-id="element-92">
              <SectionHeading title="Cine sunt eu și de ce am creat acest curs" centered={false} data-id="element-93" />
            </div>

            <div className="space-y-6 text-lg text-brand-text/80 leading-relaxed mb-10" data-id="element-94">
              <p data-id="element-95">
                Sunt <strong data-id="element-96">Adrian Huniade</strong>, Instructor Internațional
                Theta Healing® și Facilitator Heal Your Life, cu peste 25 de
                ani de experiență în terapii complementare și dezvoltare
                personală.
              </p>
              <p data-id="element-97">
                Am creat cursul Arta de a Trăi o Viață Fără Stres pentru că am
                văzut de prea multe ori ce face stresul netratat: epuizare,
                relații deteriorate, probleme de sănătate și sentimentul că
                viața trece fără să o trăiești. Și de fiecare dată, soluția nu
                era să muncești mai puțin sau să fugi de probleme. Era să înveți
                să rămâi în echilibru chiar și când viața e agitată.
              </p>
              <p data-id="element-98">
                Acest curs aduce laolaltă informații clare despre stres, tehnici
                simple de respirație și calmare pe care le poți aplica imediat,
                exerciții de reglare emoțională și metode practice de a crea
                obiceiuri sănătoase. Nu e un curs care îți spune să te relaxezi.
                E un curs care te învață cum.
              </p>

              <p className="text-xl md:text-2xl font-subtitle text-brand-purple font-medium py-4" data-id="element-99">
                Am testat fiecare tehnică din acest curs pe propria viață și cu
                sute de cursanți. Funcționează. Și funcționează rapid, dacă
                aplici.
              </p>

              <div className="p-6 bg-brand-purple/5 border-l-4 border-brand-purple rounded-r-xl" data-id="element-100">
                <p className="font-subtitle italic text-xl text-brand-text" data-id="element-101">
                  "Scopul nu e să elimini stresul. E să înveți să rămâi în
                  echilibru chiar și în mijlocul vieții."
                </p>
              </div>
            </div>

            <CTAButton className="items-start" data-id="element-102" />
          </motion.div>
        </div>
      </div>
    </section>;
}